import React from 'react';
import { TrackedLink } from './blocks';
import { FOUNDER } from '../../lib/founder';

// Fill with real, consented quotes only. The row stays hidden while this is empty.
export const TESTIMONIALS = [
  // { name: 'First name', role: 'Role, Company', photo: '/marketing/people/name.webp', quote: 'One outcome-specific sentence.' },
];

const Testimonials = ({ page }) => (
  <div className="mk-grid c3" data-testid={`${page}-testimonials`}>
    {TESTIMONIALS.map((t) => (
      <figure key={t.name} className="mk-card" style={{ margin: 0 }}>
        <blockquote style={{ margin: 0 }}><p>“{t.quote}”</p></blockquote>
        <figcaption className="mk-muted" style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 16 }}>
          {t.photo && <img src={t.photo} alt="" width="40" height="40" style={{ borderRadius: '50%' }} />}
          <span><strong>{t.name}</strong>, {t.role}</span>
        </figcaption>
      </figure>
    ))}
  </div>
);

const FoundingProgramme = ({ page }) => (
  <div className="mk-card" data-testid={`${page}-founding-programme`}>
    <p className="mk-eyebrow">Founding customer programme</p>
    <h3>We are onboarding our first customers now.</h3>
    <p>
      Simplif-i is new, so you won't find customer logos here yet. Founding customers get the £149/month
      price locked in while their subscription stays active, and work directly with the people who build the product.
      Your feedback shapes what we build next.
    </p>
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 8 }} data-testid={`${page}-trust-founder`}>
      <img src={FOUNDER.photo} alt="" width="48" height="48" loading="lazy" style={{ borderRadius: '50%', objectFit: 'cover' }} />
      <span><strong>{FOUNDER.name}</strong>, {FOUNDER.role}</span>
    </div>
    <div className="mk-actions">
      <TrackedLink to="/about" page={page} section="trust" className="mk-link" testId={`${page}-trust-about-link`}>Who is behind Simplif-i →</TrackedLink>
      <TrackedLink to="/contact?type=demo" page={page} section="trust" className="mk-link" testId={`${page}-trust-demo-link`}>Talk to us before you start →</TrackedLink>
    </div>
  </div>
);

export const TrustBlock = ({ page }) => (
  <section className="mk-section" data-testid={`${page}-trust`}>
    <div className="mk-container">
      <h2>{TESTIMONIALS.length ? 'What early customers say.' : 'Who you are buying from.'}</h2>
      {TESTIMONIALS.length ? <Testimonials page={page} /> : <FoundingProgramme page={page} />}
    </div>
  </section>
);
